export default function CF7 () {
  const INPUTS = document.querySelectorAll('input[name="page-title"]')
  const PAGE_TITLE = document.body.getAttribute('data-page-title')
  if (INPUTS.length > 0 && PAGE_TITLE) {
    for (let i = 0; i < INPUTS.length; i++) {
      INPUTS[i].value = PAGE_TITLE
    }
  }

  ServiceModalThankyou()
  CF7Tracking()
}

function ServiceModalThankyou () {
  const FORM = document.querySelector('#service-modal .wpcf7')
  if (FORM) {
    const CONTENT = document.querySelector('#service-modal .mtt-modal__content--main-content')
    const THANKYOU_CONTENT = document.querySelector('#service-modal .mtt-modal__content--thank-you')
    if (CONTENT && THANKYOU_CONTENT) {
      FORM.addEventListener('wpcf7mailsent', () => {
        CONTENT.classList.add('hide')
        THANKYOU_CONTENT.classList.remove('hide')
      }, false)
    }
  }
}

function CF7Tracking () {
  document.addEventListener('wpcf7mailsent', function(event) {
    if (event.detail.contactFormId  === 343) {
      ga( 'send', 'event', 'Kontaktformular', 'submit', 'Kontaktformular' );
      dataLayer.push({'event': 'Kontaktformular', 'formName': 'Kontaktformular'});
    } else if (event.detail.contactFormId  === 1425) {
      ga( 'send', 'event', 'Serviceformular', 'submit', 'Serviceformular' );
      dataLayer.push({'event': 'Serviceformular', 'formName': 'Serviceformular'});
    }
  }, false );
}